// extracted by mini-css-extract-plugin
module.exports = {"RulesHeaderContent":"rules-content_RulesHeaderContent__t_52N","RulesContent":"rules-content_RulesContent__1P8oa"};